<template>
    <div class="network-edit-page scrollable">
        <div class="page-header">
            <h1>{{ $route.meta.title }}</h1>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">
                    <i class="mdi mdi-home-outline"></i>
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'networks' }">
                    Networks
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="edit-form">

            <el-form
                    :model="formData"
                    status-icon
                    :rules="rulesValidate"
                    ref="networkEditForm"
                    label-width="135px"
                    class="demo-ruleForm"
            >

                <el-form-item label="Status" size="small">
                    <el-radio-group v-model="formData.status">
                        <el-radio-button :label=1>On</el-radio-button>
                        <el-radio-button :label=0>Off</el-radio-button>
                        <el-radio-button :label=2>New</el-radio-button>
                        <el-radio-button :label=3>Can't implement</el-radio-button>
                        <el-radio-button :label=4>Pending</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="Name" prop="name">
                    <el-input
                            type="text"
                            v-model="formData.name"
                            autocomplete="off"
                    ></el-input>
                </el-form-item>

                <el-form-item label="Loaded image">

                    <div class="upload-image" :class="{'err-class': ifImg}">
                        <img :src="imgPath"
                             alt=""
                             width="150"
                             height="150">
                        <i class="el-icon-upload"></i>
                        <input
                                @change="imgReader"
                                type="file"
                                accept="image/jpeg,image/png"
                                class="input-file"
                                title="drop image here">
                        <div class="el-form-item__error"
                             v-show="ifImg">Please input Network name</div>
                    </div>
                </el-form-item>

                <el-form-item label="Network Url" prop="url">
                    <el-input
                            type="text"
                            v-model="formData.url"
                            autocomplete="off"
                    ></el-input>
                </el-form-item>

                <el-form-item label="Network group" >
                    <el-select v-model="formData.group_id"  placeholder="Network" size="mini">
                      <el-option v-for="itm in this.networkGroups" :key="itm.id" :label="itm.name" :value="itm.id" ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="Free scan" size="small">
                    <el-radio-group v-model="formData.free_scan">
                        <el-radio-button :label="0">No</el-radio-button>
                        <el-radio-button :label="1">Yes</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="Work" size="small">
                    <el-radio-group v-model="formData.work">
                        <el-radio-button :label="1">Active</el-radio-button>
                        <el-radio-button :label="0">Not Active</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="Responses" size="small">
                    <el-radio-group v-model="formData.responses">
                        <el-radio-button :label="1">True</el-radio-button>
                        <el-radio-button :label="0">False</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="Captcha" size="small">
                    <el-radio-group v-model="formData.captcha">
                        <el-radio-button :label="1">True</el-radio-button>
                        <el-radio-button :label="0">False</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="Tag">
                  <el-select
                      v-model="formData.assignedTags"
                      filterable
                      allow-create
                      multiple
                      placeholder="Select a tag"
                  >
                    <el-option
                        v-for="item in networkTags"
                        :key="item.name"
                        :label="item.name"
                        :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Comment" prop="comment">
                    <el-input
                            type="textarea"
                            rows="5"
                            autocomplete="off"
                            v-model="formData.comment"
                    ></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitForm('networkEditForm')">Save</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'

  function isURL(str) {
    var pattern = new RegExp('^((ft|htt)ps?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name and extension
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?'+ // port
      '(\\/[-a-z\\d%@_.~+&:]*)*'+ // path
      '(\\?[;&a-z\\d%@_.,~+&:=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return pattern.test(str);
  }

  let validateUrl = (rule, value, callback) => {
    if(value.length < 15){
      callback(new Error('The url must be at least 15 characters.'));
    }else{
      if(!isURL(value)){
        callback(new Error('The url is not valid.'));
      }
      callback();
    }
  }

  export default {
    name: 'NetworksEdit',
    data () {
      return {
        urlRequest: '',
        formData: {
          group_id: 1,
          /*status: 0,*/
          free_scan: 0,
          url: '',
          logo_path: '/storage/networks/logo/',
          comment : "",
          captcha : "",
          work  : "",
          responses : "",
          function: "",
          assignedTags: []
        },
        rulesValidate: {
          name: [{required: true, message: 'Please input Network name. Name unique', trigger: 'blur'}],
          url: [{ required: true, validator: validateUrl,  trigger: 'blur'}],
          /*tag: [{required: true, message: 'Please input TAG', trigger: 'blur'}],
          comment: [{required: true, message: 'Please input Network comment', trigger: 'blur'}],*/
        },
        imageUrl: '',
        inputFile: '',
        fileName: 'Drop image here',
        ifImg: false,
        imageAttached: false,
        dataForRequest: new FormData(),
      }
    },
    computed: {
      ...mapGetters({
        networkData: 'networks/getNetworkShow',
        networkGroups: 'networks/getNetworkGroups',
        networkTags: 'networks/getNetworkTags',
      }),
      imgPath () {
        if (this.formData.logo_path && this.networkData.logo_name) {
          return `${process.env.VUE_APP_API_URL}${this.formData.logo_path}${this.networkData.logo_name}`
        }
      },
    },
    watch: {
      networkData: function (val) {
        let copy = {...this.formData, ...val}
        this.formData = copy
        this.formData.logo = copy.logo_name
        if (this.$route.params.id) {
          this.urlRequest = `/network/${val.id}/upload-image`
        }

      },
    },

    created () {
      if (this.$route.params.id) {
        this.$store.dispatch('networks/networkShow', this.$route.params.id)
      } else {
        this.$store.dispatch('networks/clearCurrentNetwork')
      }
      this.$store.dispatch('networks/networkGroups')
      this.$store.dispatch('networks/networkTags')

      let copy = {...this.formData, ...this.networkData}
      this.formData = copy
    },
    methods: {
      imgReader (input) {

        let file = input.srcElement.files[0]

        const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/jpg'
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isJPG) {
          this.$message.error('Image picture must be JPG format!')
          return isJPG
        }
        if (!isLt2M) {
          this.$message.error('Image picture size can not exceed 2MB!')
          return isLt2M
        }

        this.$store.dispatch('networks/uploadImage', file).then(r => {
          this.imageAttached = true
          this.formData.logo = r.logo
        })
      },

      submitForm (formName) {
        this.$refs[formName].validate(valid => {
          if (!valid) {
            Message({
              message: 'Form is not valid!',
              type: 'error',
              duration: 5 * 1000,
            })

            return false
          }

          // previously we also needed an image attached for creation (&& this.imageAttached)
          if (!this.$route.params.id) {
            this.$store.dispatch('networks/createNetwork', this.formData).then((resp) => {
              this.$router.push({name:"networks"})
            })
          } else {
            this.$store.dispatch('networks/updateNetworks', this.formData)
          }

          return true
        })
      },
    },
  }
</script>

<style lang="scss">
    .upload-image {
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        line-height: 146px;
        vertical-align: top;
        display: flex;
        align-items: center;
        justify-content: center;
        input[type=file] {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            z-index: 10;
            opacity: 0;
            cursor: pointer;
        }
        i[class^="el-icon-"] {
            position: absolute;
            z-index: 1;
            font-size: 2em;
        }
        img {
            position: absolute;
            object-fit: cover;
            z-index: 9;
        }
    }

    .upload-image:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .cust-box {
        background-color: #FFFFFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        min-height: 40px;
        line-height: 40px;
        outline: none;
        padding: 0 15px;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;

    }

    .upload-image-create {
        position: relative;
        cursor: pointer;
        input[type="file"] {
            cursor: pointer;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
        }
    }

    .file-name {
        padding: 0 10px;
    }

    .err-class {
        border-color: #ec205f;
    }

    .el-form-item__error{
        bottom: -5px;
        padding-top: 0;
    }
</style>
